<template>
  <v-app>
    <v-container>
      <!-- Add v-sheet for border -->
      <v-sheet class="bordered-sheet" elevation="0">
        <!-- Title -->
        <v-row class="title-row">
          <v-col cols="12">
            <h1>Mechanical Seal Failure Record Sheet</h1>
          </v-col>
        </v-row>

        <!-- Header Section -->
        <v-row class="header-section">
          <v-col cols="4" class="label-field-pair">
            <div class="label">Company:</div>
            <v-text-field></v-text-field>
          </v-col>
          <v-col cols="4" class="label-field-pair">
            <div class="label">Ref No:</div>
            <v-text-field></v-text-field>
          </v-col>
          <v-col cols="4" class="label-field-pair">
            <div class="label">Date:</div>
            <v-text-field></v-text-field>
          </v-col>
        </v-row>
        <v-row class="header-section">
          <v-col cols="4" class="label-field-pair">
            <div class="label">Seal Type:</div>
            <v-text-field></v-text-field>
          </v-col>
          <v-col cols="4" class="label-field-pair">
            <div class="label">Size:</div>
            <v-text-field></v-text-field>
          </v-col>
          <v-col cols="4" class="label-field-pair">
            <div class="label">Materials:</div>
            <v-text-field></v-text-field>
          </v-col>
        </v-row>

        <!-- Seal Parts Section -->
        <v-row class="header-section">
          <v-col cols="4">
            <div class="label">Seal Parts to be Returned to Customer:</div>
            <v-checkbox label="Yes"></v-checkbox>
            <v-checkbox label="No"></v-checkbox>
            <v-checkbox label="Recondition"></v-checkbox>
          </v-col>
          <v-col cols="4">
            <div class="label">Ports Present:</div>
            <v-checkbox label="BI"></v-checkbox>
            <v-checkbox label="BO"></v-checkbox>
            <v-checkbox label="Flush"></v-checkbox>
          </v-col>
          <v-col cols="4">
            <div class="label">Ports Plugged:</div>
            <v-checkbox label="BI"></v-checkbox>
            <v-checkbox label="BO"></v-checkbox>
            <v-checkbox label="Flush"></v-checkbox>
          </v-col>
        </v-row>
        <v-row class="header-section">
          <v-col cols="12" class="label-field-pair">
            <div class="label">Comments:</div>
            <v-text-field></v-text-field>
          </v-col>
        </v-row>

        <!-- Visual Examination Details: Inboard Sealing Faces -->
        <v-row class="section-divider">
          <v-col cols="12">
            <h2>Visual Examination Details - Inboard Sealing Faces</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Stationary Seal Face (STAT)</p></v-col>
          <v-col cols="1"><p>Stat</p></v-col>
          <v-col cols="2"><p>Rot</p></v-col>
          <v-col cols="2"><p>Stationary Seal Face (STAT)</p></v-col>
          <v-col cols="1"><p>Stat</p></v-col>
          <v-col cols="2"><p>Rot</p></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Drive Damage</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_Drive_Damage"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_Drive_Damage"></v-checkbox></v-col>
          <v-col cols="2"><p>Cracked</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_Cracked"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_Cracked"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Blistering</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_Blistering"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_Blistering"></v-checkbox></v-col>
          <v-col cols="2"><p>Coked / Deposits</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_Coked_Deposits"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_Coked_Deposits"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Excessive Wear</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_Excessive_Wear"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_Excessive_Wear"></v-checkbox></v-col>
          <v-col cols="2"><p>Erosion</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_Erosion"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_Erosion"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Heat Check</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_Heat_Check"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_Heat_Check"></v-checkbox></v-col>
          <v-col cols="2"><p>Chemical Attack</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_Chemical_Attack"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_Chemical_Attack"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Chipped OD</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_Chipped_OD"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_Chipped_OD"></v-checkbox></v-col>
          <v-col cols="2"><p>Chipped ID</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_Chipped_ID"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_Chipped_ID"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Shattered</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_Shattered"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_Shattered"></v-checkbox></v-col>
          <v-col cols="2"><p>Other</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_Other"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_Other"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="label-field-pair">
            <div class="label">Comments:</div>
            <v-text-field></v-text-field>
          </v-col>
        </v-row>

        <!-- Visual Examination Details: Outboard Sealing Faces -->
        <v-row class="section-divider">
          <v-col cols="12">
            <h2>Visual Examination Details - Outboard Sealing Faces</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Stationary Seal Face (STAT)</p></v-col>
          <v-col cols="1"><p>Stat</p></v-col>
          <v-col cols="2"><p>Rot</p></v-col>
          <v-col cols="2"><p>Stationary Seal Face (STAT)</p></v-col>
          <v-col cols="1"><p>Stat</p></v-col>
          <v-col cols="2"><p>Rot</p></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Drive Damage</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_OUT_Drive_Damage"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_OUT_Drive_Damage"></v-checkbox></v-col>
          <v-col cols="2"><p>Cracked</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_OUT_Cracked"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_OUT_Cracked"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Blistering</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_OUT_Blistering"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_OUT_Blistering"></v-checkbox></v-col>
          <v-col cols="2"><p>Coked / Deposits</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_OUT_Coked_Deposits"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_OUT_Coked_Deposits"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Excessive Wear</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_OUT_Excessive_Wear"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_OUT_Excessive_Wear"></v-checkbox></v-col>
          <v-col cols="2"><p>Erosion</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_OUT_Erosion"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_OUT_Erosion"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Heat Check</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_OUT_Heat_Check"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_OUT_Heat_Check"></v-checkbox></v-col>
          <v-col cols="2"><p>Chemical Attack</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_OUT_Chemical_Attack"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_OUT_Chemical_Attack"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Chipped OD</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_OUT_Chipped_OD"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_OUT_Chipped_OD"></v-checkbox></v-col>
          <v-col cols="2"><p>Chipped ID</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_OUT_Chipped_ID"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_OUT_Chipped_ID"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Shattered</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_OUT_Shattered"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_OUT_Shattered"></v-checkbox></v-col>
          <v-col cols="2"><p>Other</p></v-col>
          <v-col cols="1"><v-checkbox value="STAT_OUT_Other"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox value="ROT_OUT_Other"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="label-field-pair">
            <div class="label">Comments:</div>
            <v-text-field></v-text-field>
          </v-col>
        </v-row>

        <!-- Wear Track Symptoms Inboard and Outboard -->
        <v-row class="section-divider">
          <v-col cols="6">
            <h2>Wear Track Symptoms Inboard</h2>
            <v-row>
              <v-col cols="12">
                <v-checkbox label="Wear Track Wider Than Narrow Seal Face Width"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox label="Off Centre Wear Track"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox label="Uneven Wear Track"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox label="Not Tracking"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox label="ID Wear"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox label="OD Wear"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="label-field-pair">
                <div class="label">Comments:</div>
                <v-text-field></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <h2>Wear Track Symptoms Outboard</h2>
            <v-row>
              <v-col cols="12">
                <v-checkbox label="Wear Track Wider Than Narrow Seal Face Width"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox label="Off Centre Wear Track"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox label="Uneven Wear Track"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox label="Not Tracking"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox label="ID Wear"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox label="OD Wear"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="label-field-pair">
                <div class="label">Comments:</div>
                <v-text-field></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- Secondary & Tertiary Seals -->
        <v-row class="section-divider">
          <v-col cols="12">
            <h2>Secondary & Tertiary Seals</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Elastomers (underline)</p></v-col>
          <v-col cols="2"><p>Orings</p></v-col>
          <v-col cols="2"><p>Gasket</p></v-col>
          <v-col cols="2"><p>Bellows</p></v-col>
          <v-col cols="2"><p>Wedges</p></v-col>
          <v-col cols="2"><p>Omitted</p></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><v-checkbox label="Misaligned"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Squared"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Twisted"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Torn"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Hardened"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Yes"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><v-checkbox label="Blistering"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Cracked"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Twisted"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Torn"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Hardened"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="No"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><v-checkbox label="Cut"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Swollen"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Melted"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Melted"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Melted"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Other"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><v-checkbox label="Extruded"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Melted"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Melted"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Melted"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Melted"></v-checkbox></v-col>
          <v-col cols="2"><v-text-field label="Comments"></v-text-field></v-col>
        </v-row>

        <!-- Seal Hardware Section -->
        <v-row class="section-divider">
          <v-col cols="12">
            <h2>Seal Hardware</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Omitted / Misassembled</p></v-col>
          <v-col cols="2"><v-checkbox label="Grub Screws"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Springs"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Sleeve"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Gland"></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox label="Other Parts"></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Mechanical Damage</p></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Thermal Discolouration</p></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Wear</p></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Chemical Attack (Corroded / Pitted)</p></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Clogged / Deposits</p></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="2"><p>Other</p></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
          <v-col cols="2"><v-checkbox></v-checkbox></v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="label-field-pair">
            <div class="label">Comments:</div>
            <v-text-field></v-text-field>
          </v-col>
        </v-row>

        <!-- Summary Section -->
        <v-row class="section-divider">
          <v-col cols="12" class="label-field-pair">
            <div class="label">Summary:</div>
            <v-textarea rows="4"></v-textarea>
          </v-col>
        </v-row>

        <!-- Compiled by Engineer Section -->
        <v-row>
          <v-col cols="12" class="label-field-pair">
            <div class="label">Compiled By Engineer:</div>
            <v-text-field></v-text-field>
          </v-col>
        </v-row>
      </v-sheet>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'MechanicalSealFailureRecordSheet',
  data() {
    return {
      // Data properties for managing form state can be added here
    };
  },
};
</script>

<style scoped>
.bordered-sheet {
  border: 2px solid black;
  padding: 20px;
  margin: 20px;
}
.title-row {
  text-align: center;
  margin-bottom: 20px;
}
.header-section, .section-divider {
  border-bottom: 1px solid black;
  margin-bottom: 20px;
}
h1, h2 {
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0;
}
p {
  font-weight: bold;
}
.label-field-pair {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.label-field-pair .label {
  min-width: 150px;
  font-weight: bold;
  margin-right: 10px;
}
</style>
